import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const useAuthAdmin = () => localStorage.getItem("loggedInAdmin");

export const ProtectedRoutesAdmin = () => {
  const isAuth = useAuthAdmin();

  return isAuth ? <Outlet /> : <Navigate to="/login" />;
};

/**
 * صلاحيات المستخدم المخزّنة محلياً.
 *
 * تُقرأ بحذر: قيمة التخزين قد تكون مفقودة، أو النص "undefined" حين يفشل
 * الخادم في إرجاع الصلاحيات فيُخزَّن ناتج JSON.stringify(undefined)، أو نصاً
 * تالفاً. كانت JSON.parse تُطلق استثناءً في هذه الحالات فتُسقط شجرة React
 * بالكامل (القائمة الجانبية تستدعيها لكل عنصر عند الإقلاع).
 */
export const getStoredPermissions = () => {
  const raw = localStorage.getItem("permissionsAdmin");

  if (!raw || raw === "undefined" || raw === "null") return [];

  try {
    const parsed = JSON.parse(raw);

    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn("[auth] قائمة الصلاحيات المخزّنة تالفة — تم تجاهلها", error);

    return [];
  }
};

export const checkPermission = (permission) =>
  getStoredPermissions().includes(permission);
